import { render, staticRenderFns } from "./btn-icon-secondary.vue?vue&type=template&id=096158f8&scoped=true&"
import script from "./btn-icon-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-icon-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096158f8",
  null
  
)

export default component.exports